import { emitActionViewEvent, emitFreshViewEvent, emitDeselectShoeSizeFilterEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels) => {
    const { labels } = cinemaTracking;
    const parsedCinemaIndex = Number.parseInt(cinemaIndex, 10);
    const featureNumber = Number.isNaN(parsedCinemaIndex) ? undefined : parsedCinemaIndex === 99 ? 99 : parsedCinemaIndex + 1;

    return {
        ...cinemaTracking,
        position: Number(featureIndex),
        status: "loaded",
        labels: {
            ...labels,
            promo_Feature: ["true"],
            promo_FilledSlots: labels.promo_FilledSlots,
            ...(featureNumber && { promo_FeatureNumber: [`${featureNumber}`] }),
            ...additionalTrackingLabels,
        },
    };
};
const buildRecommendation = (recommendationTracking) => ({
    ...recommendationTracking,
    status: "loaded",
});

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

/**
 *
 */
const track = ({
    cinemaTracking,
    recommendationsTracking,
    featureIndex,
    cinemaIndex,
    eventMergeId,
    additionalTrackingLabels,
    actionName,
    baseLevelTrackingLabels,
}) => {
    const recommendationEvents = recommendationsTracking.map((it) => buildRecommendation(it));
    const event = [buildCinema(cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels), ...recommendationEvents];
    if (actionName === "deselect") {
        emitDeselectShoeSizeFilterEvent(event);
        return;
    }
    if (eventMergeId) {
        emitActionViewEvent(event, eventMergeId, actionName);
        return;
    }
    emitFreshViewEvent(event, baseLevelTrackingLabels ?? {});
};

export default track;
